<template>
  <div v-if="model" class="customer-also-bought">
    <v-container>
      <ProductCard />
      <v-row
        v-if="hasAdditionalProductGroup"
        v-bind="{ justify: 'center' }"
      >
        <div class="title-customer-also-bought">
          <h1 class="text-center">
            อุปกรณ์เสริมราคาพิเศษเมื่อซื้อคู่กัน
          </h1>
        </div>
      </v-row>
      <template v-if="hasAdditionalProductGroup">
        <v-row
          v-for="(item, index) in additionalProductGroup"
          :key="index"
        >
          <v-col>
            <v-row v-bind="{ justify: 'start' }">
              <v-col>
                <h2>{{ item.group }}</h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <template v-if="item.products.length > 0">
                  <AdditionProductSwiper
                    @select="onClickAdditionProduct"
                    :data="item.products"
                  />
                </template>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </template>
    </v-container>
    <div class="footer-margin"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ProductCard from '@/components/bnn/ProductCard'
import AdditionProductSwiper from '@/components/bnn/AdditionProductSwiper'
import cartSummary from '@/mixins/cartSummary'

export default {
  mixins: [cartSummary],

  computed: {
    ...mapState({
      isLoading: state => state.model.isLoading,
      isLoaded: state => state.model.isLoaded,
      additionalProductGroup: state => state.model.additionalProduct,
      model: state => state.model.selectModel,
      selects: state => state.bundle.selects,
    }),

    hasAdditionalProductGroup() {
      return this.additionalProductGroup?.length > 0
    },
  },

  data() {
    return {}
  },

  mounted() {
    if (!this.hasAdditionalProductGroup) {
      this.$router
        .push({
          name: 'Cart',
          params: {
            slug: this.slug,
          },
        })
        .catch(() => true)
    }

    if (!this.model) {
      this.$router
        .push({
          name: 'ProductDetail',
          params: {
            slug: this.$route.params?.slug,
          },
        })
        .catch(() => true)
    }
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
    this.checkSummary()
  },

  methods: {
    onClickAdditionProduct(item) {
      this.$store.dispatch('bundle/toggle', item)
      this.$forceUpdate()
    },
  },

  components: {
    ProductCard,
    AdditionProductSwiper,
  },
}
</script>

<style lang="stylus" scoped>

.customer-also-bought {
  background: $color-bnn-gray-light-2 0% 0% no-repeat padding-box
  height 100%
  width 100%
  margin-top: 75px
}

.title-customer-also-bought {
    padding: 0 0 2.5rem 0

    @media small {
      font-size: 0.85rem
    }
}

.footer-margin
    margin-bottom: 150px;

@media screen and (max-width: 960px)
  .footer-margin
    margin-bottom: 170px;
</style>
